/**
 * 为元素添加id的插件，包含以下功能
 * 添加 v-id 指令，自动为元素添加id，如 v-id="'add-btn'"
 * 而且，绑定指令的元素被遍历，也会在id上加上下标，所以无需对v-for的元素做特殊处理
 *
 * 目前内置了一种参数类型 v-id:input ， 可以直接定义组件内部的input元素的id，后面可以通过 customHandle 自定义处理, 如对ant组件的处理
 *
 * 目前id的下标是自动生成的，可以通过 v-id.noIndex 取消自动生成下标, 这时候就需要自行通过  v-id.noIndex="`list-item-${index}`" 来控制下标
 *
 * @param {*} Vue
 * @param {(el, binding, vnode, index): void} options.customHandle 自定义处理，会额外传入元素下标，可以自定义处理一些特殊情况
 */
const AutoIdPlugin = {
  install(Vue, options) {
    let { customHandle } = options || {};

    Vue.directive("id", {
      bind(el, binding) {
        // 在首次绑定时，给元素添加一个自定义属性data-class
        el.setAttribute("data-class", `${binding.value}`);
      },
      inserted(el, binding, vnode) {
        let { arg, modifiers } = binding;

        // 在元素插入到dom时，通过data-class属性，找到所有相同data-class的元素，生成index
        let arr = document.querySelectorAll(
          `[data-class="${el.dataset.class}"]`
        );

        let index = 0;
        if (arr.length && !modifiers.noIndex) {
          index = Array.prototype.indexOf.call(arr, el);
        }

        el.id = `${el.dataset.class}-${index}`;
        el.setAttribute("autocomplete", "off"); // 设置为 off 有时候会不生效，所以设置为 none

        if (arg) {
          switch (arg) {
            case "input": {
              let inputEls = el.querySelectorAll("input");
              inputEls.forEach((item, index) => {
                item.id = `${el.id}-input-${index}`;
                item.setAttribute("autocomplete", "off");
              });

              break;
            }
          }
        }

        customHandle && customHandle(el, binding, vnode, index);
      },
    });
  },
};

export default AutoIdPlugin;

/**
 * 对ant组件库的单独处理
 * @param {*} el
 * @param {*} binding
 * @param {*} vnode
 */
export function antDHandle(el, binding, vnode, index) {
  let { arg } = binding;

  try {
    switch (arg) {
      case "radioGroup": {
        let inputEls = el.querySelectorAll("input");
        let labelEls = el.querySelectorAll("label");
        [...inputEls, ...labelEls].forEach((item, index) => {
          item.id = `${el.id}-input-${index}`;
        });

        break;
      }
      case "inputSearch": {
        let inputEl = el.querySelector("input");
        inputEl.id = `${el.id}-input`;
        inputEl.setAttribute("autocomplete", "off");
        let iconEl = el.querySelector(".anticon");
        if (iconEl) {
          iconEl.id = `${el.id}-icon`;
        }
        break;
      }
      case "tabPane": {
        let tabEls = el.querySelectorAll('[role="tab"]');
        tabEls.forEach((item, index) => {
          item.id = `${el.id}-tab-${index}`;
        });
        break;
      }
      case "pagination": {
        let prevBtn = el.querySelector(".ant-pagination-prev");
        if (prevBtn) {
          prevBtn.id = `${el.id}-prevBtn`;
        }
        let nextBtn = el.querySelector(".ant-pagination-next");
        if (nextBtn) {
          nextBtn.id = `${el.id}-nextBtn`;
        }

        let pageEls = el.querySelectorAll(".ant-pagination-item");
        pageEls.forEach((item, index) => {
          item.id = `${el.id}-item-${index}`;
        });
        break;
      }
      case "modal": {
        let closeBtn = el.querySelector(".ant-modal-close");
        if (closeBtn) {
          closeBtn.id = `${el.id}-closeBtn`;
        }

        let footerBtns = el.querySelectorAll(".ant-modal-footer .ant-btn");
        footerBtns.forEach((item, index) => {
          item.id = `${el.id}-footer-btn-${index}`;
        });
        break;
      }
    }
  } catch (error) {
    console.log(error);
  }
}
